import { useContext, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router'
import { Tab, Tabs } from '@mui/material'

import { AppContext } from '../../../providers/app-provider'
import { useAuthentication } from '../../../providers/auth-provider'
import useStyles from '../index.styles'

const TabsComponent = () => {
  const classes = useStyles

  const { hasInternalUserAccess } = useAuthentication()
  const { tenantId } = useContext(AppContext)

  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { deviceId } = useParams<{ deviceId: string }>()

  const tab = (searchParams.get('tab') as TabsListType | null) || 'alerts'

  // redirect user from channels tab if user doesn't have access to this tab
  useEffect(() => {
    if (tab === 'channels' && !hasInternalUserAccess) {
      navigate(`/tenant/${tenantId}/devices/${deviceId}`, { replace: true })
    }
  }, [tab, hasInternalUserAccess, navigate, deviceId, tenantId])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: TabsListType) => {
    if (newValue === 'alerts' || newValue === 'charts' || newValue === 'channels') setSearchParams({ tab: newValue })
  }

  return (
    <Tabs value={tab} onChange={handleTabChange} sx={classes.tabs}>
      <Tab label="Alerts" value="alerts" sx={classes.tab} />
      <Tab label="Charts" value="charts" sx={classes.tab} />
      {hasInternalUserAccess && <Tab label="Channels" value="channels" sx={classes.tab} />}
    </Tabs>
  )
}

export default TabsComponent
